<template>
  <div class="sc-object-card__list-cameras-item__wrapper">
    <div class="sc-object-card__list-cameras-item__wrapper-info">
      <r-text type="caption" :size="12">{{ $t("number") }}</r-text>
      <r-text :size="12">{{ carNumber }}</r-text>
    </div>
    <div class="sc-object-card__list-cameras-item__wrapper-info">
      <r-text type="caption" :size="12">{{ $t("registeredSpeedKMPH") }}</r-text>
      <r-text :size="12">{{ registeredSpeedKMPH }}</r-text>
    </div>
    <div class="sc-object-card__list-cameras-item__wrapper-info">
      <r-text type="caption" :size="12">{{ $t("allowedSpeedKMPH") }}</r-text>
      <r-text :size="12">{{ allowedSpeedKMPH }}</r-text>
    </div>
    <div class="sc-object-card__list-cameras-item__wrapper-info">
      <r-text type="caption" :size="12">{{ $t("registeredAt") }}</r-text>
      <r-text :size="12">{{ registeredAt }}</r-text>
    </div>
    <img
      class="sc-object-card__list-cameras-item__wrapper-image"
      :src="cameraUrl"
      alt="No-data"
    />
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    info: {
      type: Object,
      required: true,
      default: () => null
    }
  },
  computed: {
    cameraUrl() {
      const photo =
        this.info["{urn:lma:tf3:vcc-events:1.0:DataObjects}photo"] || {};
      const photoUrl =
        photo["{urn:lma:tf3:vcc-events:1.0:DataObjects}content"] || null;

      return `data:image/jpeg;base64, ${photoUrl}`;
    },
    carNumber() {
      return (
        this.info[
          "{urn:lma:tf3:vcc-events:1.0:DataObjects}transportRegNumber"
        ] || null
      );
    },
    allowedSpeedKMPH() {
      return (
        this.info["{urn:lma:tf3:vcc-events:1.0:DataObjects}allowedSpeedKMPH"] ||
        null
      );
    },
    registeredAt() {
      const value =
        this.info["{urn:lma:tf3:vcc-events:1.0:DataObjects}registeredAt"] || "";

      return moment(value).format("DD.MM.YY HH:mm");
    },
    registeredSpeedKMPH() {
      return (
        this.info[
          "{urn:lma:tf3:vcc-events:1.0:DataObjects}registeredSpeedKMPH"
        ] || null
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.sc-object-card__list-cameras-item__wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: var(--bg_containers) !important;
  padding: 4px;
  &-info {
    margin-bottom: 4px;
  }
  &-image {
    min-width: 144px;
    min-height: 100px;
    width: 100%;
    border-radius: var(--border-radius);
    height: auto;
    text-align: center;
    color: var(--text_secondary) !important;
  }
}
</style>

<i18n>
{
  "ru": {
    "number": "Номер машины:",
    "registeredSpeedKMPH": "Зарегистрированная скорость, км/ч:",
    "allowedSpeedKMPH": "Разрешенная скорость, км/ч:",
    "registeredAt": "Время регистрации:"
  },
  "en": {
    "number": "Car number:",
    "registeredSpeedKMPH": "Registered speed, km/h:",
    "allowedSpeedKMPH": "Allowed speed, km/h:",
    "registeredAt": "Registered at:"
  }
}
</i18n>
